import { Routes } from '@angular/router';
import { LayoutComponent } from './core/components/layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';

export const AppRoutes: Routes = [
  {
    path: 'login/oauth2redirect',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/public/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'login',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/public/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'Ayuda',
    loadChildren: () => import('./pages/help-view/help-view.module').then((m) => m.HelpViewModule)
  },
  {
    path: 'restore',
    loadChildren: () => import('./pages/public/restore/restore.module').then((m) => m.RestoreModule)
  },
  {
    path: 'code-verification',
    loadChildren: () => import('./pages/public/ga-token/ga-token.module').then((m) => m.GaTokenModule)
  },
  {
    path: 'create-code-ga',
    loadChildren: () =>
      import('./pages/public/go-token-register/ga-token-register.module').then((m) => m.GaTokenRegisterModule)
  },
  {
    path: 'recovery',
    loadChildren: () =>
      import('./pages/public/recovery-password/recovery-password.module').then((m) => m.RecoveryPasswordModule)
  },
  {
    path: 'activate-account',
    loadChildren: () =>
      import('./pages/public/activate-account/activate-account.module').then((m) => m.ActivateAccountModule)
  }, // seems to be unused
  {
    path: 'activate-account-responsible',
    loadChildren: () =>
      import('./pages/public/activate-account-responsible/activate-account-responsible.module').then(
        (m) => m.ActivateAccountResponsibleModule
      )
  },
  {
    path: 'remove-device',
    loadChildren: () =>
      import('./pages/public/recovery-device/recovery-device.module').then((m) => m.RecoveryDeviceModule)
  },
  {
    path: 'remove-device-request',
    loadChildren: () =>
      import('./pages/public/remove-device-request/remove-device-request.module').then(
        (m) => m.RemoveDeviceRequestModule
      )
  },
  {
    path: '',
    redirectTo: 'login/oauth2redirect',
    pathMatch: 'full'
  },
  {
    path: 'user',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule)
  },
  {
    path: 'pix',
    children: [
      {
        path: 'health',
        loadChildren: () => import('./pages/public/healthcheck/healthcheck.module').then((m) => m.HealthcheckModule)
      }
    ]
  }
];
